// components/ui/Calendar.js
import React from "react";
import { DayPicker } from "react-day-picker";
import "react-day-picker/dist/style.css";
import { cn } from "../utils/helpers";

export function Calendar({ className, ...props }) {
  return (
    <DayPicker
      showOutsideDays
      fixedWeeks
      className={cn("p-3", className)}
      {...props}
    />
  );
}
